<div class="fce-form">
	<form
		(ngSubmit)="onSubmit()"
		#componentsForm="ngForm"
		autocomplete="off"
		novalidate>
		<!-- Section 1: Personal Information -->
		<section class="fce-section">
			<div class="fce-section__header">
				<span class="fce-section__badge">01</span>
				<h2 class="fce-section__title">Personal Information</h2>
				<p class="fce-section__desc">Your contact and account details</p>
			</div>
			<div class="fce-section__body">
				<div class="fce-grid fce-grid--2">
					<eif-custom-input
						#fullNameInput
						[label]="'Full Name'"
						[placeholder]="'Enter your full name'"
						[validationRules]="getValidationRules('fullName')"
						(valueChange)="onValueChange('fullName', $event)"
						(validationChange)="onValidationChange('fullName', $event)">
					</eif-custom-input>
					<eif-custom-input
						#emailInput
						[label]="'Email Address'"
						[placeholder]="'you@example.com'"
						[type]="'email'"
						[validationRules]="getValidationRules('email')"
						(valueChange)="onValueChange('email', $event)"
						(validationChange)="onValidationChange('email', $event)">
					</eif-custom-input>
				</div>
				<div class="fce-grid fce-grid--2">
					<eif-custom-input
						#phoneInput
						[label]="'Phone Number'"
						[placeholder]="'XXX-XXX-XXXX'"
						[validationRules]="getValidationRules('phone')"
						(valueChange)="onValueChange('phone', $event)"
						(validationChange)="onValidationChange('phone', $event)">
					</eif-custom-input>
					<eif-custom-input
						#usernameInput
						[label]="'Username'"
						[placeholder]="'Choose a username'"
						[validationRules]="getValidationRules('username')"
						(valueChange)="onValueChange('username', $event)"
						(validationChange)="onValidationChange('username', $event)">
					</eif-custom-input>
				</div>
				<div class="fce-grid fce-grid--1">
					<eif-custom-input
						#passwordInput
						[label]="'Password'"
						[type]="'password'"
						[placeholder]="'Minimum 8 characters'"
						[validationRules]="getValidationRules('password')"
						(valueChange)="onValueChange('password', $event)"
						(validationChange)="onValidationChange('password', $event)">
					</eif-custom-input>
				</div>
			</div>
		</section>

		<!-- Section 2: Selection & Preferences -->
		<section class="fce-section">
			<div class="fce-section__header">
				<span class="fce-section__badge">02</span>
				<h2 class="fce-section__title">Selection & Preferences</h2>
				<p class="fce-section__desc">Choose your options and priorities</p>
			</div>
			<div class="fce-section__body">
				<div class="fce-grid fce-grid--2">
					<eif-custom-select
						#categorySelect
						[label]="'Category'"
						[placeholder]="'Select a category'"
						[options]="categoryOptions"
						[fullWidth]="true"
						[validationRules]="getValidationRules('category')"
						(valueChange)="onValueChange('category', $event)"
						(validationChange)="onValidationChange('category', $event)">
					</eif-custom-select>
					<eif-custom-select
						#countrySelect
						[label]="'Country'"
						[placeholder]="'Select your country'"
						[options]="countryOptions"
						[fullWidth]="true"
						[validationRules]="getValidationRules('country')"
						(valueChange)="onValueChange('country', $event)"
						(validationChange)="onValidationChange('country', $event)">
					</eif-custom-select>
				</div>
				<div class="fce-radio-group">
					<eif-custom-radio
						#priorityRadio
						[label]="'Priority Level'"
						[name]="'priority'"
						[options]="priorityOptions"
						[color]="'primary'"
						[validationRules]="getValidationRules('priority')"
						(validationChange)="onValidationChange('priority', $event)"
						[ngModel]="formFields.priority?.value"
						(ngModelChange)="onValueChange('priority', $event)">
					</eif-custom-radio>
				</div>
				<div class="fce-radio-group">
					<eif-custom-radio
						#shippingRadio
						[label]="'Shipping Method'"
						[name]="'shippingMethod'"
						[options]="shippingOptions"
						[color]="'info'"
						[validationRules]="getValidationRules('shippingMethod')"
						(validationChange)="onValidationChange('shippingMethod', $event)"
						[ngModel]="formFields.shippingMethod?.value"
						(ngModelChange)="onValueChange('shippingMethod', $event)">
					</eif-custom-radio>
				</div>
			</div>
		</section>

		<!-- Section 3: Quantity & Budget (Sliders) -->
		<section class="fce-section">
			<div class="fce-section__header">
				<span class="fce-section__badge">03</span>
				<h2 class="fce-section__title">Quantity & Budget</h2>
				<p class="fce-section__desc">Adjust the sliders to set your requirements</p>
			</div>
			<div class="fce-section__body">
				<div class="fce-grid fce-grid--2">
					<eif-custom-slider
						#quantitySlider
						[label]="'Quantity'"
						[min]="0"
						[max]="100"
						[step]="1"
						[maxDecimals]="0"
						[valueSuffix]="' units'"
						[validationRules]="getValidationRules('quantity')"
						(valueChange)="onValueChange('quantity', $event)"
						(validationChange)="onValidationChange('quantity', $event)">
					</eif-custom-slider>
					<eif-custom-slider
						#budgetSlider
						[label]="'Budget Range'"
						[min]="0"
						[max]="2000"
						[step]="50"
						[maxDecimals]="0"
						[valueSuffix]="' $'"
						[validationRules]="getValidationRules('budget')"
						(valueChange)="onValueChange('budget', $event)"
						(validationChange)="onValidationChange('budget', $event)">
					</eif-custom-slider>
				</div>
			</div>
		</section>

		<!-- Section 4: Scheduling (Date Pickers) -->
		<section class="fce-section">
			<div class="fce-section__header">
				<span class="fce-section__badge">04</span>
				<h2 class="fce-section__title">Scheduling</h2>
				<p class="fce-section__desc">Select your preferred dates</p>
			</div>
			<div class="fce-section__body">
				<div class="fce-grid fce-grid--2">
					<eif-custom-date-picker
						#startDatePicker
						[label]="'Start Date'"
						[placeholder]="'Select start date'"
						[validationRules]="getValidationRules('startDate')"
						(selectionChange)="onValueChange('startDate', $event)"
						(validationChange)="onValidationChange('startDate', $event)">
					</eif-custom-date-picker>
					<eif-custom-date-picker
						#endDatePicker
						[label]="'End Date'"
						[placeholder]="'Select end date'"
						[validationRules]="getValidationRules('endDate')"
						(selectionChange)="onValueChange('endDate', $event)"
						(validationChange)="onValidationChange('endDate', $event)">
					</eif-custom-date-picker>
				</div>
			</div>
		</section>

		<!-- Section 5: Toggles (Switches) -->
		<section class="fce-section">
			<div class="fce-section__header">
				<span class="fce-section__badge">05</span>
				<h2 class="fce-section__title">Preferences</h2>
				<p class="fce-section__desc">Enable or disable optional features</p>
			</div>
			<div class="fce-section__body">
				<div class="fce-switch-row">
					<eif-custom-switch
						#enableNotificationsSwitch
						[label]="'Enable notifications'"
						[color]="'info'"
						[checkedValue]="'On'"
						[uncheckedValue]="'Off'"
						[validationRules]="getValidationRules('enableNotifications')"
						(switchChange)="onValueChange('enableNotifications', $event)"
						(validationChange)="onValidationChange('enableNotifications', $event)">
					</eif-custom-switch>
					<eif-custom-switch
						#autoRenewalSwitch
						[label]="'Auto-renewal'"
						[color]="'success'"
						[checkedValue]="'Enabled'"
						[uncheckedValue]="'Disabled'"
						[validationRules]="getValidationRules('autoRenewal')"
						(switchChange)="onValueChange('autoRenewal', $event)"
						(validationChange)="onValidationChange('autoRenewal', $event)">
					</eif-custom-switch>
				</div>
			</div>
		</section>

		<!-- Section 6: Agreements (Checkboxes) -->
		<section class="fce-section">
			<div class="fce-section__header">
				<span class="fce-section__badge">06</span>
				<h2 class="fce-section__title">Agreements</h2>
				<p class="fce-section__desc">Please accept the following to continue</p>
			</div>
			<div class="fce-section__body">
				<div class="fce-checkbox-group">
					<eif-custom-checkbox
						#newsletterCheckbox
						[label]="'Subscribe to newsletter'"
						[color]="'primary'"
						[checkedValue]="'Subscribed'"
						[uncheckedValue]="'Not subscribed'"
						[validationRules]="getValidationRules('newsletter')"
						(checkedChange)="onValueChange('newsletter', $event)"
						(validationChange)="onValidationChange('newsletter', $event)">
					</eif-custom-checkbox>
					<eif-custom-checkbox
						#acceptTermsCheckbox
						[label]="'I accept the Terms and Conditions'"
						[color]="'primary'"
						[checkedValue]="'Accepted'"
						[uncheckedValue]="'Not Accepted'"
						[validationRules]="getValidationRules('acceptTerms')"
						(checkedChange)="onValueChange('acceptTerms', $event)"
						(validationChange)="onValidationChange('acceptTerms', $event)">
					</eif-custom-checkbox>
				</div>
			</div>
		</section>

		<!-- Actions -->
		<div class="fce-actions">
			<eif-custom-button
				[text]="'Submit'"
				[type]="'submit'"
				[preIcon]="'fa-solid fa-paper-plane'"
				[size]="'small'"
				[disabled]="!isFormValid">
			</eif-custom-button>
			<eif-custom-button
				[text]="'Reset'"
				[type]="'button'"
				[color]="'neutral'"
				[preIcon]="'fa-solid fa-refresh'"
				[size]="'small'"
				(click)="resetForm()">
			</eif-custom-button>
			<eif-custom-button
				[text]="'Validate All'"
				[type]="'button'"
				[color]="'info'"
				[preIcon]="'fa-solid fa-check'"
				[size]="'small'"
				(click)="onSubmit()">
			</eif-custom-button>
			<eif-custom-button
				[text]="testing ? 'Testing...' : 'Test Form'"
				[type]="'button'"
				[color]="'warning'"
				[preIcon]="'fa-solid fa-flask'"
				[size]="'small'"
				[loading]="testing"
				(click)="testFormFunctionality()">
			</eif-custom-button>
		</div>

		<!-- Form Status (ds-value style - matches component showcase) -->
		<section class="ds-status ds-mt-2">
			<h4 class="ds-status__title">Form Status</h4>
			<div class="ds-status__grid">
				<div
					class="ds-value"
					[class.ds-value--success]="isFormValid"
					[class.ds-value--error]="!isFormValid">
					<div class="ds-value__label">Valid:</div>
					<div class="ds-value__content">{{ isFormValid ? 'Yes' : 'No' }}</div>
				</div>
			</div>
		</section>

		<!-- Current Form Values (merged: valid icon + value per field) -->
		<section class="ds-status ds-mt-2">
			<h4 class="ds-status__title">Current Form Values</h4>
			<div class="ds-status__grid">
				@for (entry of getFormFieldEntries(); track entry) {
					<div class="ds-value ds-mt-1">
						<div class="ds-value__label">{{ entry.label }}</div>
						<div class="ds-value__content fce-value-with-icon">
							<span
								class="fce-value-icon"
								[class.fce-value-icon--valid]="formFields[entry.key]?.valid"
								[class.fce-value-icon--invalid]="!formFields[entry.key]?.valid">
								{{ formFields[entry.key]?.valid ? '✓' : '✗' }}
							</span>
							{{ getFieldDisplayValue(entry.key) }}
						</div>
					</div>
				}
			</div>
		</section>
	</form>
</div>
